export default Object.freeze({
  Form: 1,
  PDFTemplate: 2,
  Action: 3,
  CreationUserHandler: 4,
  RevisionUserHandler: 5,
  ObservationUserHandler: 6,
  VoidedUserHandler: 7,
  EmailTemplate: 8,
  ProcessCustomNotification: 9,
  CustomList: 10,
  Variable: 11,
  DownloadMassiveLoadRequestsExcelFormat: 12,
  UploadMassiveLoadRequestsExcelFormat: 13,
});
